export default __webpack_public_path__ + "static/media/352.3647e471.jpg";